<div class="modal-header">
  <h4 class="modal-title">Export Event Attendees</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="form-group">
    <label for="downloadFileNameInput">Download File Name</label>
    <input type="text" class="form-control" id="downloadFileNameInput" name="downloadFileName"
           [(ngModel)]="downloadFileName">
  </div>

  <div class="form-group">
    <label>Columns:</label>
    <br>
    <b>General</b>
    <button class="btn btn-link btn-sm p-0 float-right"
            *ngIf="!allColumnsAreSelected()"
            (click)="setAllColumnsSelected(true)">
      Select All
    </button>
    <button class="btn btn-link btn-sm p-0 float-right"
            *ngIf="allColumnsAreSelected()"
            (click)="setAllColumnsSelected(false)">
      Deselect All
    </button>
    <div class="form-check" *ngFor="let columnName of genericColumnNames; let colIdx = index;">
      <input class="form-check-input" type="checkbox" [id]="'generic' + colIdx + 'checkbox'"
             [(ngModel)]="selectedColumns[columnName]">
      <label class="form-check-label" [for]="'generic' + colIdx + 'checkbox'">
        {{ columnName }}
      </label>
    </div>
    <ng-container *ngIf="attendeeQuestionColumnNames.length > 0">
      <b>Attendee Questions</b>
      <div class="form-check" *ngFor="let columnName of attendeeQuestionColumnNames; let colIdx = index;">
        <input class="form-check-input" type="checkbox" [id]="'attendeeQuestion' + colIdx + 'checkbox'"
               [(ngModel)]="selectedColumns[columnName]">
        <label class="form-check-label" [for]="'attendeeQuestion' + colIdx + 'checkbox'">
          {{ columnName }}
        </label>
      </div>
    </ng-container>
    <ng-container *ngIf="bookingQuestionColumnNames.length > 0">
      <b>Booking Questions</b>
      <div class="form-check" *ngFor="let columnName of bookingQuestionColumnNames; let colIdx = index;">
        <input class="form-check-input" type="checkbox" [id]="'bookingQuestion' + colIdx + 'checkbox'"
               [(ngModel)]="selectedColumns[columnName]">
        <label class="form-check-label" [for]="'bookingQuestion' + colIdx + 'checkbox'">
          {{ columnName }}
        </label>
      </div>
    </ng-container>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button type="button" class="btn btn-primary"
          [disabled]="noColumnsAreSelected()"
          [class.disabled]="noColumnsAreSelected()"
          (click)="handleSubmit()">
    Export
  </button>
</div>
